// extracted by mini-css-extract-plugin
export default {"Disclosure":"TermsOfUse_Disclosure__xB2VC","SectionTitle":"TermsOfUse_SectionTitle__l7HZX","Note":"TermsOfUse_Note__68LUC"};